import { inject } from '@angular/core';
import { type ResolveFn, Router } from '@angular/router';
import { of, switchMap, catchError } from 'rxjs';

import { QuestionsService } from '@shared/services/questions.service';
import { CommonDataService } from '@shared/services/common-data.service';
import type { SuitabilityResponse } from '@shared/interfaces/question.interface';
import type { PortfolioApiResponse } from '@shared/interfaces/portfolio.interface';
import { isNullOrUndefined } from '@utils/predicates';
import { PATHS, CURRENCY, CLIENT_TYPE } from '@constants';

export interface SuitabilityResultInitData {
  testResult: SuitabilityResponse;
  portfolios: PortfolioApiResponse | null;
}

export const suitabilityResultResolver: ResolveFn<SuitabilityResultInitData | null> = () => {
  const questionsService = inject(QuestionsService);
  const commonData = inject(CommonDataService);
  const router = inject(Router);

  const survey = commonData.get('survey');
  if (isNullOrUndefined(survey)) {
    router.navigate([PATHS.questions]);
    return of(null);
  }

  return questionsService.getTestResult(survey.surveyId).pipe(
    switchMap((testResult) => {
      const riskLevel = testResult.data.risk;
      if (riskLevel <= CURRENCY.ZERO_AMOUNT) {
        return of({ testResult, portfolios: null });
      }
      return questionsService.getPortfolios(riskLevel, CLIENT_TYPE, testResult.data.investmentAmount).pipe(
        catchError(() => of(null)),
        switchMap((portfolios) => of({ testResult, portfolios }))
      );
    })
  );
};
